import { Routes } from '#config/routes';
import { graphql, rest } from 'msw';
import { isValidEmail } from '#utils/validators';
import {
  ContentType,
  GetMediaPlayerDataQuery,
  GetMediaPlayerDataQueryVariables,
  GetSeriesPlaylistQuery,
  GetSeriesPlaylistQueryVariables,
  MediaType,
  ProductType,
} from '#types/generated/graphql-types';

type NewsletterSubscriptionParams = {
  email: string;
  locale: string;
};

export const handlers = [
  rest.post<NewsletterSubscriptionParams>(
    Routes.NEWSLETTER_API,
    (req, res, ctx) => {
      if (!isValidEmail(req.body.email)) {
        return res(
          ctx.status(400),
          ctx.json({
            message: 'invalid email',
          })
        );
      }

      return res(ctx.status(200));
    }
  ),

  graphql.query<GetMediaPlayerDataQuery, GetMediaPlayerDataQueryVariables>(
    'GetMediaPlayerData',
    (_req, res, ctx) => {
      return res(
        ctx.data({
          media: {
            id: 299,
            iri: '/api/vms/videos/299',
            categories: [
              {
                id: 13,
                iri: '/api/vms/categories/13',
                contentType: ContentType.Category,
                slug: 'info',
                title: 'Info',
                __typename: 'Category',
              },
              {
                id: 24,
                iri: '/api/vms/categories/24',
                contentType: ContentType.Category,
                slug: 'kids',
                title: 'Kids',
                __typename: 'Category',
              },
            ],
            contentType: ContentType.Video,
            mediaType: MediaType.Episode,
            posterImage: null,
            playerData: {
              source: {
                url: 'https://development1.cdn.veejoy.de/main-playlist/407/1027/main.m3u8?signature=eyJzaWduYXR1cmUiOiJxUzF2RmR1eGNmeHcwYUtCTzc2ZzZcL3pLKys0PSIsImV4cGlyYXRpb25fdGltZXN0YW1wIjoiMTY3NzQ5ODczMiJ9',
                duration: 472,
                tracks: [
                  {
                    url: 'https://development1.cdn.veejoy.de/main-playlist/407/1027/main.m3u8?signature=eyJzaWduYXR1cmUiOiJxUzF2RmR1eGNmeHcwYUtCTzc2ZzZcL3pLKys0PSIsImV4cGlyYXRpb25fdGltZXN0YW1wIjoiMTY3NzQ5ODczMiJ9',
                    language: 'de',
                    __typename: 'StandardTrack',
                  },
                ],
                __typename: 'Playlist',
              },
              subtitles: {
                assetFormats: [
                  {
                    language: 'fr',
                    contentUrl:
                      'https://development1.cdn.veejoy.de/media/fc63ab0d29fb74ef081984e1d9ba3a4269d54a45f74332aa26.srt?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=sonata-media%40epcloud-stage-dev.iam.gserviceaccount.com%2F20230227%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20230227T085212Z&X-Goog-Expires=43200&X-Goog-SignedHeaders=host&X-Goog-Signature=9c5d8ce2279d927a77e2f90d36e4e3e40f29692a8d1eb7c0acd3baa7352638f1f48db496d32b977771ddd4dcd69dc33493788f44c8565262d15737bfc791cd9970b8c45523744e3322b259fe98e3a312fb3746634502e9b9c6e56734dae71e363536b9005ee216554ca6112920bebe90eeea6946bfb82e895606d469dd3d0117b5fbbd3ae8cd00216365326b9a4095f7693fdd6f13da9ca627529c2e0b05f685328ec8206605282cd88a7d1fdddc3ee926b51be88373ec91d1b8d73a5882d6318b9a80a42c5810bdb050a9a87cc67ff6f7f92a92e8862d89c7ec04c7100fa3568127ef621dcc6e1a4014747b7b83e8bcb997f7a59532e278c0e2258cecd499da',
                    __typename: 'AssetFormat',
                  },
                ],
                __typename: 'Asset',
              },
              rolls: [
                {
                  source: {
                    url: 'https://development1.cdn.veejoy.de/main-playlist/1515/6395/main.m3u8?signature=eyJzaWduYXR1cmUiOiJaaEllYnFjSzJUVHV0XC9GTHRDUExUS0JsNW1VPSIsImV4cGlyYXRpb25fdGltZXN0YW1wIjoiMTY3NzQ5ODczMyJ9',
                    duration: 11,
                    tracks: [
                      {
                        url: 'https://development1.cdn.veejoy.de/main-playlist/1515/6395/main.m3u8?signature=eyJzaWduYXR1cmUiOiJaaEllYnFjSzJUVHV0XC9GTHRDUExUS0JsNW1VPSIsImV4cGlyYXRpb25fdGltZXN0YW1wIjoiMTY3NzQ5ODczMyJ9',
                        language: 'any',
                        __typename: 'StandardTrack',
                      },
                    ],
                    __typename: 'Playlist',
                  },
                  iri: '/api/vms/media_assets/902',
                  type: 'PRE_ROLL',
                  isSkippable: false,
                  __typename: 'MediaRoll',
                },
              ],
              product: {
                id: '/api/vms/products/45',
                price: null,
                type: ProductType.Free,
                __typename: 'Product',
              },
              __typename: 'MediaPlayerData',
            },
            seriesSlug: 'europa-park-weekly',
            slug: 'die-neue-dinner-show-special',
            state: 'live',
            studio: {
              id: 4,
              iri: '/api/vms/studios/4',
              contentType: ContentType.Studio,
              title: 'MACK Media',
              slug: 'mack-media',
              __typename: 'Studio',
            },
            season: {
              id: 14,
              series: {
                id: 9,
                iri: '/api/vms/series/9',
                contentType: ContentType.Series,
                title: 'Europa-Park Weekly',
                slug: 'europa-park-weekly',
                __typename: 'Series',
              },
              __typename: 'Season',
            },
            title: 'Die neue Dinner-Show Special',
            __typename: 'Media',
          },
        })
      );
    }
  ),

  graphql.query<GetSeriesPlaylistQuery, GetSeriesPlaylistQueryVariables>(
    'GetPlaylist',
    (_req, res, ctx) => {
      return res(
        ctx.data({
          seriesPlaylist: [
            {
              id: 141,
              episodeIri: '/api/vms/videos/141',
              episodeNumber: 17,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 140,
              episodeIri: '/api/vms/videos/140',
              episodeNumber: 16,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 227,
              episodeIri: '/api/vms/videos/227',
              episodeNumber: 15,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 229,
              episodeIri: '/api/vms/videos/229',
              episodeNumber: 11,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 299,
              episodeIri: '/api/vms/videos/299',
              episodeNumber: 9,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 230,
              episodeIri: '/api/vms/videos/230',
              episodeNumber: 8,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 231,
              episodeIri: '/api/vms/videos/231',
              episodeNumber: 7,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 228,
              episodeIri: '/api/vms/videos/228',
              episodeNumber: 5,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
            {
              id: 123,
              episodeIri: '/api/vms/videos/123',
              episodeNumber: 4,
              seasonNumber: 1,
              seasonIri: '/api/vms/seasons/14',
              __typename: 'PlaylistItem',
            },
          ],
        })
      );
    }
  ),
];
